export const onlyImageHeight = 'min-h-[500px] 2xl:min-h-[641px] aic-2k:min-h-[728px] h-full '
export const imageAndContentHeight = 'min-h-[500px] h-full '

// export const parallaxStyle = 'w-screen bg-cover bg-fixed bg-bottom bg-no-repeat'
export const parallaxStyle = 'w-screen bg-no-repeat bg-bottom bg-cover'

export const basicStyle = 'w-screen bg-no-repeat bg-bottom bg-cover'

export const motionStyles = {
  initial: {
    opacity: 0,
    scale: 0.3,
    filter: 'blur(20px)',
  },
  animate: {
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)',
  },
  transition: {
    type: 'spring',
    bounce: 0,
    duration: 0.5,
  },
}

export const overlayStyles = {
  backgroundColor: 'rgba(27, 31, 36, 0.15)',
}
